export default "__VITE_ASSET__CLfXj2Ly__"